





































































































import '../../styles/upsert-contact-modal.css'
import Vue from 'vue'
import { CIcon } from '@coreui/icons-vue'
import { cilCamera, cilX } from '@coreui/icons-pro'

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

import Modal from '../general/modal/Modal.vue'
import ModalBody from '../general/modal/ModalBody.vue'
import { IValidationResult } from '../../util/IValidationResult'

interface IModel {
  cameraIcon: any[]
  exitIcon: any[]
  errors: string[]
  firstName: string
  lastName: string
  company: string
  department: string
  position: string
  email: string
  phoneNumber: string
  imageData: string
}

export default Vue.extend({
  mixins: [validationMixin],
  validations: {
    firstName: { required },
    lastName: { required },
    department: { required },
    email: { required, email },
    phoneNumber: { required },
  },
  data: () => {
    return {
      cameraIcon: cilCamera,
      exitIcon: cilX,
      errors: [],
      saving: false,
      firstName: '',
      lastName: '',
      company: '',
      department: '',
      position: '',
      email: '',
      phoneNumber: '',
      imageData: '',
    }
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    contact: {
      type: Object,
      required: false,
      default: null,
    },
  },
  watch: {
    contact: function (val) {
      this.firstName = val.firstName
      this.lastName = val.lastName
      this.company = val.company
      this.department = val.department
      this.position = val.position
      this.email = val.email
      this.phoneNumber = val.phoneNumber
    },
  },
  updated: function () {
    if (this.$refs.fileinput) {
      ;(this.$refs.fileinput as HTMLInputElement).onchange = () => {
        const files = (this.$refs.fileinput as HTMLInputElement).files

        if (files && files.length > 0) {
          const file = files[0]
          if (file) {
            this.imageData = URL.createObjectURL(file)
          }
        }
      }
    }
  },
  methods: {
    submit: async function () {
      if (
        this.$v.firstName.$invalid ||
        this.$v.lastName.$invalid ||
        this.$v.department.$invalid ||
        this.$v.email.$invalid ||
        this.$v.phoneNumber.$invalid
      ) {
        this.$v.$touch()
        return
      }

      this.saving = true

      const result = await fetch('/api/contacts', {
        method: this.editMode ? 'PUT' : 'POST',
        body: JSON.stringify({
          id: this?.contact?.id,
          firstName: this.firstName,
          lastName: this.lastName,
          company: this.company,
          department: this.department,
          position: this.position,
          phoneNumber: this.phoneNumber,
          email: this.email,
          hasCustomImage: !!this.imageData || !!this.contact.imageUrl,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
      if (!result.ok) {
        this.errors = (await result.json()).map(
          (x: IValidationResult) => x.errorMessage
        )
      } else {
        const body = await result.json()
        const files = (this.$refs.fileinput as HTMLInputElement).files
        if (files && files.length > 0) {
          const file = files[0]
          if (file) {
            const uploadImageUrl = body.uploadImageUrl
            await fetch(uploadImageUrl, {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': 'image/png',
                'x-ms-blob-type': 'BlockBlob',
              },
            })
          }
        }

        this.close(body)
      }

      this.saving = false
    },
    selectFile: async function (): Promise<void> {
      ;(this.$refs.fileinput as HTMLInputElement).click()
    },
    close(data: IModel | undefined): void {
      this.firstName = ''
      this.lastName = ''
      this.company = ''
      this.department = ''
      this.position = ''
      this.email = ''
      this.phoneNumber = ''
      this.imageData = ''

      this.$v.$reset()
      this.$emit('close', data)
    },
  },
  computed: {
    firstNameErrors(): string[] {
      const errors: string[] = []
      if (this.$v.firstName.$error) errors.push('First name is required')
      return errors
    },
    lastNameErrors(): string[] {
      const errors: string[] = []
      if (this.$v.lastName.$error) errors.push('Last name is required')
      return errors
    },
    departmentErrors(): string[] {
      const errors: string[] = []
      if (this.$v.department.$error) errors.push('Department is required')
      return errors
    },
    emailErrors(): string[] {
      const errors: string[] = []
      if (this.$v.email.$error) {
        if (this.$v.email.email) errors.push('Must be valid email')
        if (this.$v.email.required) errors.push('Email is required')
      }
      return errors
    },
    phoneNumberErrors(): string[] {
      const errors: string[] = []
      if (this.$v.phoneNumber.$error) errors.push('Phone number is required')
      return errors
    },
  },
  components: { CIcon, Modal, ModalBody },
  name: 'UpsertContactModal',
})
